import { matchPath } from "react-router";
import { SUPPORT_LOCATIONS } from "./locations";

const PATTERNS = Object.keys(SUPPORT_LOCATIONS).sort((a, b) => b.length - a.length);

export function matchSupportPage(pathname: string): string | null {
  return PATTERNS.find((pattern) => matchPath({ path: pattern, end: true }, pathname)) ?? null;
}
